import {useLayerContext} from '@toolify/client/src/modules/routes/composables/useLayerContext'

export function useLocalRoute() {
  return useLayerContext().route
}
